import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IconClose from '../../../assets/icons/IconClose'
import { checkTimeCanAddFood, formatMoney, getFoodPriceShow } from '../../../utils'
import { getFullFileUrl } from '../../../utils/formatData'
import { clsx } from '../../../utils/helper'
import BaseModal from '../../common/base-modal'
import ModalHeader from '../../common/base-modal/ModalHeader'

import Modal from '../../common/modal'
import AmountButton from '../../elements/AmountButton'
import Button from '../../elements/Button'
import FormatCurrency from '../../elements/FormatCurrency'
import Separate from '../../elements/Separate'
import WrapIcon from '../../elements/WrapIcon'
import InputSelect from '../../form/InputSelect'
import Textarea from '../../form/Textarea'
import GroupTopping from '../elements/GroupTopping'

const FoodDetails = ({
    food,
    handleChangeTopping,
    isUpdate,
    handleSubmit,
    formData,
    handleChange,
    money,
    onClose,
    foodSubs,
    handleChangeFoodShow,
    foodParent,
    foodShowIndex,
    isOpen,
    isFoodDisabled,
    validTimeAddFood
}) => {
    const { t } = useTranslation();
    const [moreInfo, setMoreInfo] = useState('');

    useEffect(() => {
        let timeOutScroll
        if (!!food) {
            timeOutScroll = setTimeout(() => {
                const el = document.querySelector('.food-details-modal')
                if (el) {
                    el.scrollTop = 0
                }
            })
        }

        return () => {
            timeOutScroll && clearTimeout(timeOutScroll)
        }
    }, [food])

    const validFoodTime = !!foodParent && checkTimeCanAddFood(foodParent)
    const { beilageItems = [] } = food || {}
    const { currentPrice, originPrice, total } = money;
    const imgBanner = food?.imagePath || foodParent?.imagePath;

    return (
        <>
            <Modal className="food-details-modal" isOpen={isOpen}>
                {food && (
                    <div
                        className={clsx([
                            'food-details f-modal',
                            !validFoodTime && 'disable-action',
                        ])}
                    >
                        <div className="container-fluid container-xl">
                            <div className="main-content">
                                <div
                                    className={clsx(
                                        'food-details--banner',
                                        (imgBanner) && 'with-banner'
                                    )}
                                >
                                    <div className="wrap-btn-close">
                                        <WrapIcon
                                            onClick={onClose}
                                            size="24px"
                                            icon={IconClose}
                                            color="ffffff"
                                        />
                                    </div>
                                    <img
                                        alt="banner"
                                        src={getFullFileUrl(imgBanner)}
                                    />
                                </div>
                                <div className="food-details__head-info">
                                    <div className="food-details__head-info__head flex-between">
                                        <div className="info">
                                            <div className="info--name heading-6">
                                                {foodParent.name}
                                            </div>
                                        </div>

                                        {!food.pluGroup && (
                                            <div className="price">
                                                <div className="price--current">
                                                    <FormatCurrency
                                                        amount={currentPrice}
                                                    />
                                                </div>
                                                {!!originPrice && (
                                                    <div className="price--old label-3">
                                                        <FormatCurrency
                                                            amount={originPrice}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="info--description mt-1 label-3">
                                        {foodParent.description}
                                    </div>

                                    {!!foodSubs?.length && (
                                        <div className="mt-2">
                                            <InputSelect
                                                options={foodSubs.map(
                                                    (el, index) => (
                                                        <option
                                                            key={el.id}
                                                            value={index}
                                                        >
                                                            {el.name} ({formatMoney(getFoodPriceShow(el).currentPrice)})
                                                        </option>
                                                    )
                                                )}
                                                onChange={e =>
                                                    handleChangeFoodShow(
                                                        e.target.value
                                                    )
                                                }
                                                value={foodShowIndex}
                                            />
                                        </div>
                                    )}
                                </div>

                                {beilageItems.length !== 0 && (
                                    <Separate height={3} color="color-4" />
                                )}

                                <div className="list-group-topping">
                                    {beilageItems.map((group, index) => (
                                        <GroupTopping
                                            id={`beilage-${index}`}
                                            handleChangeTopping={indexTopping => handleChangeTopping(index, indexTopping)}
                                            listChecked={formData.beilageItems[index] || []}
                                            item={group}
                                            key={group.group_name}
                                            setMoreInfo={setMoreInfo}
                                        />
                                    ))}
                                </div>

                                <div className="food-instruction mt-2 mb-4">
                                    <Textarea
                                        label={t('modalFoodDetailsMobile.lbNote')}
                                        tag="textarea"
                                        rows={3}
                                        onChange={e =>
                                            handleChange('note', e.target.value)
                                        }
                                        value={formData.note}
                                    />

                                    <div className="food-instruction__amount mt-6">
                                        <AmountButton
                                            onClick={() =>
                                                handleChange(
                                                    'amount',
                                                    formData.amount - 1
                                                )
                                            }
                                        />

                                        <div className="px-4 heading-5">
                                            {formData.amount}
                                        </div>

                                        <AmountButton
                                            add
                                            onClick={() =>
                                                handleChange(
                                                    'amount',
                                                    formData.amount + 1
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="wrap-btn-submit">
                                <Button
                                    disabled={!validTimeAddFood || isFoodDisabled}
                                    onClick={handleSubmit}
                                >
                                    {t(
                                        isUpdate
                                            ? 'modalFoodDetailsMobile.btnUpdateCart'
                                            : 'modalFoodDetailsMobile.btnAddToCart'
                                    )}
                                    {!food.pluGroup && (
                                        <>
                                            {' +'}
                                            <FormatCurrency amount={total} />
                                        </>
                                    )}
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </Modal>
            <BaseModal
                isOpen={!!moreInfo}
                contentClassName="food-info-more"
                onRequestClose={() => setMoreInfo('')}
            >
                <ModalHeader onClose={() => setMoreInfo('')}>{t('modalMoreInfo.title')}</ModalHeader>
                <div
                    className="content paragraph-2 mt-4"
                    dangerouslySetInnerHTML={{ __html: moreInfo }}
                />
            </BaseModal>
        </>
    )
}

export default FoodDetails
